import ReactDOM from "react-dom/client";
import React from "react";
import EshopConfiguration from "../services/EshopConfiguration";
import pageTypeResolveService from "../services/PageTypeResolveService";
import ProductDetailPageTypeConfig from "../detail/ProductDetailPageTypeConfig";
import { Currency } from "../../../js/common/CurrencyFormatter";
import ajaxClient from "../../../js/common/AjaxClient";
import NewcomerPopupModal from "./components/NewcomerPopupModal";

interface NewcomerPopupResponse {
    readonly unlimitedDiscount: {
        readonly value: number;
        readonly code: string;
    };
    readonly limitedDiscount: {
        readonly value: number;
        readonly code: string;
        readonly amount: number;
    };
    readonly gaSession: boolean;
    readonly currencyId: Currency;
}

export default new class NewcomerPopupService {
    private productDetailPageTypeConfig: ProductDetailPageTypeConfig | undefined;

    public init(eshopConfiguration: EshopConfiguration): void {
        if (!eshopConfiguration.showNewcomerPopup || this.getProductDetailType() === "sold") {
            return;
        }

        globalThis.setTimeout(() => void this.openNewcomerPopup(), 5000);
    }

    private async openNewcomerPopup(): Promise<void> {
        try {
            const newcomerPopupResponse = await ajaxClient.get<NewcomerPopupResponse>("/Customer/jsNewcomerPopup");

            this.showNewcomerPopup(newcomerPopupResponse);
        } catch {
            // Ignore errors, we do not want to block the page loading
        }
    }

    private showNewcomerPopup(response: NewcomerPopupResponse): void {
        if (!response.gaSession) {
            return;
        }

        const popupContainer = document.createElement("div");
        const root = ReactDOM.createRoot(popupContainer);

        document.body.appendChild(popupContainer);

        root.render(<NewcomerPopupModal
            unlimitedDiscountCode={response.unlimitedDiscount.code}
            unlimitedDiscountValue={response.unlimitedDiscount.value}
            limitedDiscountCode={response.limitedDiscount.code}
            limitedDiscountValue={response.limitedDiscount.value}
            limitedDiscountCodeAmount={response.limitedDiscount.amount}
            mode={this.resolvePopupMode()}
            onAfterClose={(): void => {
                root.unmount();
                popupContainer.remove();
            }}
            currency={response.currencyId}
        />);
    }

    private getProductDetailType(): "multi" | "sold" {
        this.productDetailPageTypeConfig ??= pageTypeResolveService.getConfig<ProductDetailPageTypeConfig>();

        return this.productDetailPageTypeConfig.detailType;
    }

    private resolvePopupMode(): "detail" | "general" {
        if (!pageTypeResolveService.isProductDetail()) {
            return "general";
        }

        return "detail";
    }
}();
